<script>
import storeMixin from '../store/mixin';

export default {
    name: 'ListMixin',
    mixins: [storeMixin],
    data() {
        return {
            mixinLoading: false,
            mixinItems: null,
            mixinAutoFetch: true,
            mixinSize: 10,
            mixinCount: 0,
            mixinPage: 1,
        };
    },
    computed: {
        mixinParamsConnector() {
            return ~this.mixinUrl.indexOf('?') ? '&' : '?';
        },
    },
    created() {
        if (this.mixinAutoFetch) {
            this.mixinGetList();
        }
    },
    methods: {
        async mixinGetList() {
            if (!this.mixinUrl) return console.error('mixinUrl needed.');
            if (this.mixinLoading) return;
            this.mixinLoading = true;
            try {
                const result = await this.REQUEST({
                    url: `${this.mixinUrl}${this.mixinParamsConnector}limit=${this.mixinSize}&size=${this.mixinSize}&page=${this.mixinPage}`,
                });
                if (result.code == 10004) {
                    window.localStorage.user = '';
                    this['USER/SET_STATE']({
                        key: 'TOKEN',
                        value: '',
                    });
                    this.$router.push('/login');
                    return;
                }
                this.mixinItems = result.data.items;
                this.mixinCount = result.data.count;
            } catch (e) {
                console.log(e);
            }
            this.mixinLoading = false;
        },
        pageChange(n) {
            this.mixinPage = n;
            this.mixinGetList();
        },
    },
};
</script>
